module.exports = __webpack_public_path__ + "img/controle_de_fluxo_de_trafego.452b7b78.png";